import './src/scss/fonts.scss';

import availableWidgets from './src/components/widgets/available-widgets';
import PageViewer from './src/components/PageViewer.vue';
import Controller from './src/components/widgets/Controller.vue';
import ControllerSection from './src/components/widgets/ControllerSection.vue';
import getNaturalSize from './src/components/widgets/image/image-utils';

export default {
  availableWidgets,
  PageViewer,
  imageUtils: {
    getNaturalSize,
  },
  editor: {
    Controller,
    ControllerSection,
  },
};
